import Image from "next/image"

/**
 * Trust-badge row shown below the Add to Cart / PayPal buttons on the PDP —
 * the reference site renders this as a single pre-composed sprite image
 * rather than individual icons, so we use the same asset (1352x104 native)
 * instead of recreating each badge.
 */
export default function PaymentIcons() {
  return (
    <Image
      src="/images/payment-icon/payments-strip.png"
      alt="payments-accepted"
      width={1352}
      height={104}
      className="w-full max-w-[500px] h-auto"
    />
  )
}
